<script setup lang="ts">
// AppShell — slot-based wrapper providing the 64px header + main content area.
// Per UI-SPEC §17: app shell 100vw/100vh; header 64px; content fills remaining height.
import AppHeader from './AppHeader.vue'
</script>

<template>
    <div class="flex h-full flex-col" style="background-color: var(--color-surface-base)">
        <AppHeader />
        <main class="min-h-[calc(100vh-64px)] flex-1 overflow-auto">
            <slot />
        </main>
    </div>
</template>
